import PhotoSwipe from 'vue-simple-photoswipe'
import Vue from 'vue'

Vue.use(PhotoSwipe)
